import { useEffect } from 'react';

import { site } from '@/content/site';

type Meta = {
  title: string;
  description: string;
  /** Chemin canonique, ex. `/blog`. */
  path: string;
};

function setAttribute(selector: string, attribute: string, value: string) {
  document.head.querySelector(selector)?.setAttribute(attribute, value);
}

/** Tient à jour titre, description et URL canonique au fil des routes. */
export function useDocumentMeta({ title, description, path }: Meta): void {
  useEffect(() => {
    const url = `${site.url}${path}`;

    document.title = title;
    setAttribute('meta[name="description"]', 'content', description);
    setAttribute('meta[property="og:title"]', 'content', title);
    setAttribute('meta[property="og:description"]', 'content', description);
    setAttribute('meta[property="og:url"]', 'content', url);
    setAttribute('meta[name="twitter:title"]', 'content', title);
    setAttribute('meta[name="twitter:description"]', 'content', description);
    setAttribute('link[rel="canonical"]', 'href', url);
  }, [title, description, path]);
}
